<template>
  <div v-if="show" class="loading-overlay">
    <div class="loading-content">
      <div class="spinner"></div>
      <p class="loading-message">{{ message }}</p>
      <p v-if="total" class="total-info">
        You will see a charge for <strong>${{ formattedTotal }}</strong> by AI CAPTAINS LLC
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingOverlay',
  props: {
    show: {
      type: Boolean,
      required: true
    },
    message: {
      type: String,
      default: 'Processing payment...'
    },
    total: {
      type: Number,
      default: null
    }
  },
  computed: {
    formattedTotal() {
      return this.total ? (this.total / 100).toFixed(2) : '0.00';
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.loading-content {
  background: #2d2d2d;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #3d3d3d;
  text-align: center;
}

.spinner {
  display: inline-block;
  width: 50px;
  height: 50px;
  border: 5px solid rgba(65, 216, 246, 0.3);
  border-radius: 50%;
  border-top-color: #FFD23F;
  animation: spin 1s ease-in-out infinite;
  margin: 0 auto 1.5rem;
}

.loading-message {
  color: #e0e0e0;
  font-size: 1.2rem;
  margin: 0 0 1rem 0;
}

.total-info {
  color: #b0b0b0;
  font-size: 1rem;
  margin: 1rem 0 0 0;
  padding-top: 1rem;
  border-top: 1px solid #3d3d3d;
}

.total-info strong {
  color: #FFD23F;
  font-weight: bold;
  font-size: 1.1rem;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}
</style> 